import type { TFunction } from "i18next";
import { z } from "zod";

const ids = z.array(z.string());

const zeroOrRange = (min: number, max: number, message: string) =>
  ids.refine((arr) => arr.length === 0 || (arr.length >= min && arr.length <= max), {
    message,
  });

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const getVideoGenFormSchema = (t: TFunction<any, any>) =>
  z.discriminatedUnion("enableInspirationAssetSelection", [
    z.object({
      enableInspirationAssetSelection: z.literal(false),
      asin: z.string().optional(),
      productId: z.number().optional(),
      name: z.string().min(
        1,
        t(($) => $.validation["Name is required"]),
      ),
      brandLogoAssetIds: ids,
      lifestyleImageAssetIds: ids,
      videoAssetIds: ids,
    }),

    z.object({
      enableInspirationAssetSelection: z.literal(true),
      asin: z.string().optional(),
      productId: z.number().optional(),
      name: z.string().min(
        1,
        t(($) => $.validation["Name is required"]),
      ),
      brandLogoAssetIds: ids.max(
        1,
        t(($) => $.validation["If including a brand logo, only 1 may be selected."]),
      ),
      lifestyleImageAssetIds: zeroOrRange(
        4,
        10,
        t(($) => $.validation["If including lifestyles images, between 4 and 10 must be selected."]),
      ),
      videoAssetIds: zeroOrRange(
        4,
        10,
        t(($) => $.validation["If including videos, between 4 and 10 must be selected."]),
      ),
    }),
  ]);

export type FormValues = z.infer<ReturnType<typeof getVideoGenFormSchema>>;
